<template>
	<div
		class="g-block-title-pill g-block-title-padding"
		:class="{
			'g-block-title-pill--edit': editable,
			'is-active': editable && active,
			'g-block-title-pill--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div
			class="g-block-title-pill__inner"
			:style="{ color: themeColor, borderColor: themeColor }"
		>
			<RichTextEditable
				v-if="editable"
				class="g-block-title-pill__text"
				fit-content
				:model-value="data.content"
				placeholder="请输入标题"
				@update:model-value="onContentUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-title-pill__text"
				v-html="data.content || ''"
			></div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { getTitleThemeColor } from '../../../templates.js';

	export default {
		name: 'GBlockTitlePill',
		components: { RichTextEditable },
		props: {
			data: {
				type: Object,
				required: true,
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['select', 'update'],
		computed: {
			themeColor() {
				return getTitleThemeColor(this.data);
			},
		},
		methods: {
			onWrapClick(e) {
				if (!this.editable) return;
				e?.stopPropagation?.();
				this.$emit('select');
			},
			onContentUpdate(content) {
				this.$emit('update', { content });
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-title-pill {

		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}

	.g-block-title-pill__inner {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		max-width: 100%;
		padding: 6px 16px;
		border: 1px solid currentColor;
		border-radius: 999px;
		box-sizing: border-box;
	}

	.g-block-title-pill__text {
		display: inline-flex;
		align-items: center;
		font-size: 16px;
		font-weight: 400;
		line-height: 1.2;
		padding: 0;
		font-family: inherit;
		word-break: break-word;
		white-space: pre-wrap;
		color: inherit;

		:deep(.g-rich-text-editable) {
			display: inline-flex;
			align-items: center;
			width: auto;
			max-width: 100%;
			color: inherit;
		}

		:deep(.g-rich-text-editable__content) {
			line-height: 1.2;
			min-height: unset;
			height: auto;
			padding: 0;
			color: inherit;
			font-weight: 400;
		}

		:deep(span),
		:deep(font),
		:deep(p),
		:deep(div) {
			line-height: inherit;
			margin: 0;
			padding: 0;
			vertical-align: baseline;
			color: inherit;
		}
	}

	.g-block-title-pill--h5 {
		.g-block-title-pill__inner {
			padding: 0.12rem 0.32rem;
		}

		.g-block-title-pill__text {
			font-size: 0.32rem;
		}
	}
</style>
